import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Heading from '../heading/Heading';
import Icon from '../icon/Icon';
import {CustomPropTypes, sizes} from '../../constants';

import styles from './WarningTemplate.pcss';

class WarningTemplate extends PureComponent {
    static propTypes = {
        children: PropTypes.any,
        className: PropTypes.string,
        contentBackgroundText: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        contentDescription: PropTypes.string,
        contentIcon: CustomPropTypes.icon,
        contentMessage: PropTypes.string,
        pageTitle: PropTypes.string,
        isLauncher: PropTypes.bool
    };

    render() {
        const {
            className,
            contentBackgroundText,
            contentDescription,
            contentIcon,
            contentMessage,
            pageTitle,
            isLauncher
        } = this.props;

        const wrapperClassName = cx(styles.wrapper, className, {
            [styles.isLauncher]: isLauncher
        });

        return (
            <div className={wrapperClassName}>
                {pageTitle && (
                    <Heading className={styles.pageTitle} level={1}>
                        {pageTitle}
                    </Heading>
                )}

                <div className={styles.contentWrapper}>
                    <div className={styles.messageWrapper}>
                        {contentBackgroundText && (
                            <div className={styles.messageBackgroundText}>
                                {contentBackgroundText}
                            </div>
                        )}
                        {contentIcon && (
                            <Icon
                                className={styles.messageIcon}
                                icon={contentIcon}
                                size={sizes.LARGE}
                            />
                        )}
                        <p className={styles.messageText}>{contentMessage}</p>
                        {contentDescription && (
                            <p className={styles.messageDescription}>{contentDescription}</p>
                        )}
                    </div>

                    {this.props.children && (
                        <div className={styles.childrenWrapper}>{this.props.children}</div>
                    )}
                </div>
            </div>
        );
    }
}

export default WarningTemplate;
